import { defineMessages } from "react-intl"

export const messages = defineMessages({
    toggleEnabled: {
        id: "recurring_payment_options_dropdown.toggle_enabled",
        defaultMessage: "Enabled",
    },
    toggleSendEmail: {
        id: "recurring_payment_options_dropdown.toggle_send_email",
        defaultMessage: "Automatically send emails",
    },
    toggleAttachPdf: {
        id: "recurring_payment_options_dropdown.toggleAttachPdf",
        defaultMessage: "Attach account statement pdf",
    },
    togglePaymentCapture: {
        id: "recurring_payment_options_dropdown.payment_method_selector.toggle_payment_capture",
        defaultMessage: "Automatically capture with payment method on file if exists",
    },
    creditCard: {
        id: "recurring_payment_options_dropdown.payment_method_selector.credit_card",
        defaultMessage: "Default credit card on file",
    },
    ach: {
        id: "recurring_payment_options_dropdown.payment_method_selector.ach",
        defaultMessage: "Default bank account on file",
    },
    paymentMethodSelectLabel: {
        id: "recurring_payment_options_dropdown.payment_method_selector.choose_payment_method_label",
        defaultMessage: "Choose the payment method:",
    },
})


// WEBPACK FOOTER //
// ./src/common/recurring-options-dropdown/messages.ts